import google_close from '../assets/google_close.svg'

export default function SideBarTitle ({toggleSidebar}) {
    return (
        <div style={{display: 'flex', marginBottom: '15px'}}>
            <h3 style={{color: 'green', margin: 0}}>Catgories</h3>
            <button onClick={toggleSidebar}>
                <img src={google_close}></img>
            </button>
        </div>
    )
}